export { default } from './RoutineInfo';

